module.exports = __webpack_public_path__ + "static/media/CORN_YELLOW_1x.5bbe2643.png";